import { initDrawers } from 'theme/drawer';
import { initProductForms } from 'theme/product-form';
import { initCart } from 'theme/cart';
import { initSearch } from 'theme/search';
import { initMenus } from 'theme/menu';
import { initFacets } from 'theme/facets';
import { initLangSuggest } from 'theme/lang-suggest';
import { initNewsletterModal } from 'theme/newsletter-modal';
initDrawers();
initProductForms();
initCart();
initSearch();
initMenus();
initFacets();
initLangSuggest();
initNewsletterModal();

